import { LIST_QUERY } from '../../../graphql/shopping-list';

/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */

class Action {
  constructor({ component }) {
    this.component = component;
  }

  static get name() { return 'Action'; }

  execute() {
    this.component.synching = true;
    return this._executeImpl().finally(() => {
      this.component.synching = false;
    });
  }

  // Optimistic UI or subscription change
  updateQuery(/* cachedShoppingList, change */) {
    throw new Error('Execute Not Implemented');
  }

  _executeImpl() {
    throw new Error('Execute Not Implemented');
  }

  _updateCache(store, changeResult, args) {
    const id = this.component.shoppingList.id;
    const data = store.readQuery({ query: LIST_QUERY, variables: { id } });
    this.updateQuery(data.shoppingList, changeResult, args);
    if (changeResult.modifiedAt) {
      data.shoppingList.modifiedAt = changeResult.modifiedAt;
    }

    store.writeQuery({ query: LIST_QUERY, variables: { id }, data });
  }
}

class UndoAction extends Action {
  constructor({ component, undoAction }) {
    super({ component });
    this.undoAction = undoAction;
  }

  static get name() { return 'UndoAction'; }

  // eslint-disable-next-line
  undo() {
    throw new Error('Undo Not Implemented');
  }

  // eslint-disable-next-line
  updateItem() {
    throw new Error('Update Item Not Implemented');
  }

  // eslint-disable-next-line
  undoTooltip() {
    throw new Error('Undo Tooltip Not Implemented');
  }

  // eslint-disable-next-line
  redoTooltip() {
    throw new Error('Redo Tooltip Not Implemented');
  }
}

export { Action, UndoAction };



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/Action.js